export const LOCAL_DEV_AUTH_HEADER = "x-qms-local-dev-auth";
export const LOCAL_DEV_SESSION = {
  authenticated: true,
  user: {
    sub: "local-quality-manager",
    name: "Desenvolvimento Local",
    email: "dev.sistemas@flexibase.local",
    role: "quality_manager",
    permissions: ["*"],
  },
} as const;

export function isLocalDevAuthEnabled() {
  if (!import.meta.env.DEV || typeof window === "undefined") return false;
  return import.meta.env.VITE_AUTH_MODE !== "sso";
}

export function getLocalDevAuthHeaders(): Record<string, string> {
  return isLocalDevAuthEnabled() ? { [LOCAL_DEV_AUTH_HEADER]: "1" } : {};
}
